import React from 'react';
import PropTypes from 'prop-types';

import 'src/react/recommendations/components/ToggleButton/ToggleButton.scss';

const toggleButtonProps = {
  className: PropTypes.string,
  children: PropTypes.node,
  isActive: PropTypes.bool
};

const ToggleButton = (props) => {
  const { className, children, isActive, ...otherProps } = props;
  const activeClass = isActive ? 'is-active' : '';
  const combinedClasses = [
    'ToggleButton font-gibson font-semibold py-1',
    activeClass,
    className
  ].join(' ');

  return (
    <button {...otherProps} className={combinedClasses}>
      {children}
    </button>
  );
};
ToggleButton.propTypes = { ...toggleButtonProps };

export default ToggleButton;
